import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncPrismicMain = Load(() => import('./PrismicMain'));

const PrismicRoutes = [
  <Route
    key={'prismic'}
    path={`${basePath}/prismic`}
    component={AsyncPrismicMain}
  />,
];

export default PrismicRoutes;
